export const COUNTER_CARDS = [
    {
        id: "c1",
        title: "Verify a health claim, This card will verify if a health claim is true or false",
        type: "counter",
        image: "c1.png",
        name: "Scalpel Says So",
    },
    {
        id: "c2",
        title: "This card will verify if the scientific claim is grounded in peer-reviewed research or just hot air.",
        type: "counter",
        image: "c2.png",
        name: "Peer Pressure",
    },
    {
        id: "c3",
        title: "This card will verify if that shocking headline is real news or just noise.",
        type: "counter",
        image: "c3.png",
        name: "Bitter Truth",
    },
    {
        id: "c4",
        title: "This card will diagnose health myths and prescribe the truth.",
        type: "counter",
        image: "c4.png",
        name: "Whodoo Magic",
    },
    {
        id: "c5",
        title: "This card will uncover the scientific truth using peer-reviewed research and verified studies.",
        type: "counter",
        image: "c5.png",
        name: "Lab Rats",
    },
    {
        id: "c6",
        title: "This card enforces verified health guidelines straight from trusted government sources.",
        type: "counter",
        image: "c6.png",
        name: "Sanity Stamp",
    },
    {
        id: "c7",
        title: "This card uses AI-powered detection to separate fact from fiction with precision and speed.",
        type: "counter",
        image: "c7.png",
        name: "AI-ce breaker",
    },
    {
        id: "c8",
        title: "Global Fact Check Network This card taps into global fact-checking networks to verify worldwide claims and bust myths.",
        type: "counter",
        image: "c8.png",
        name: "Truth Network",
    },
    {
        id: "c9",
        title: "This card dives into digital archives to trace the origins of claims and uncover the real story.",
        type: "counter",
        image: "c9.png",
        name: "Wayback Wizard",
    },
];

// export const CLAIM_CARDS = [
//     // Round 1 (Basic misinformation)
//     // { id: "m1", title: "Eucalyptus leaves cure cancer", type: "claim", image: "m1.png", round: 1, counterId: "c1" },
//     { id: "m1", title: "Drinking bleach detoxifies the body", type: "claim", image: "m2.png", round: 1, counterId: "c1" },
//     // { id: "m3", title: "We only use 10% of our brains", type: "claim", image: "m3.png", round: 1, counterId: "c4" },
//     { id: "m2", title: "The Great Wall of China is visible from space", type: "claim", image: "m4.png", round: 1, counterId: "c4" },
//     { id: "m3", title: "Sunlight kills all viruses instantly", type: "claim", image: "m5.png", round: 1, counterId: "c6" },
//     { id: "m4", title: "Holding breath for 10 seconds proves you're virus-free", type: "claim", image: "m6.png", round: 1, counterId: "c3" },

//     // Round 2 (Slightly more elaborate claims)
//     { id: "m5", title: "Homeopathy is a proven COVID cure", type: "claim", image: "m7.png", round: 2, counterId: "c2" },
//     // { id: "m8", title: "Herbal tea eliminates all toxins", type: "claim", image: "m8.png", round: 2, counterId: "c5" },
//     // { id: "m9", title: "Misinformation is okay if it makes people feel safe", type: "claim", image: "m9.png", round: 2, counterId: "c3" },
//     { id: "m6", title: "You can detox through your feet", type: "claim", image: "m10.png", round: 2, counterId: "c1" },
//     { id: "m7", title: "Wearing copper bracelets boosts immunity", type: "claim", image: "m11.png", round: 2, counterId: "c5" },
//     { id: "m8", title: "Natural remedies are always safe", type: "claim", image: "m12.png", round: 2, counterId: "c6" },

//     // Round 3 (Viral social media myths)
//     { id: "m9", title: "Bill Gates owns the WHO", type: "claim", image: "m14.png", round: 3, counterId: "c8" },
//     // { id: "m15", title: "Climate change is a hoax", type: "claim", image: "m15.png", round: 3, counterId: "c8" },
//     // { id: "m16", title: "5G towers spread COVID", type: "claim", image: "m16.png", round: 3, counterId: "c2" },
//     { id: "m10", title: "DNA upgrades unlock psychic abilities", type: "claim", image: "m29.png", round: 3, counterId: "c7" },
//     { id: "m11", title: "5G towers spread dangerous radiation", type: "claim", image: "m17.png", round: 3, counterId: "c4" },
//     { id: "m12", title: "Social distancing is a government control tactic", type: "claim", image: "m18.png", round: 3, counterId: "c3" },

//     // Round 4 (Conspiratorial narratives)
//     { id: "m13", title: "The moon landing was faked", type: "claim", image: "m19.png", round: 4, counterId: "c9" },
//     // { id: "m20", title: "The Earth is flat", type: "claim", image: "m20.png", round: 4, counterId: "c5" },
//     { id: "m14", title: "Scientists are paid to lie about climate change", type: "claim", image: "m21.png", round: 4, counterId: "c3" },
//     { id: "m15", title: "Big Pharma suppresses all cures", type: "claim", image: "m22.png", round: 4, counterId: "c5" },
//     { id: "m16", title: "The government controls weather with chemtrails", type: "claim", image: "m23.png", round: 4, counterId: "c8" },
//     // { id: "m24", title: "Aliens built the pyramids", type: "claim", image: "m24.png", round: 4, counterId: "c9" },

//     // Round 5 (Deeply misleading pseudoscience)
//     { id: "m17", title: "Quantum healing can cure cancer instantly", type: "claim", image: "m25.png", round: 5, counterId: "c5" },
//     // { id: "m26", title: "Energy crystals balance your immune system", type: "claim", image: "m26.png", round: 5, counterId: "c1" },
//     // { id: "m27", title: "Miracle mineral solution cures all diseases", type: "claim", image: "m27.png", round: 5, counterId: "c1" },
//     { id: "m18", title: "Time-travelers warned us about pandemics", type: "claim", image: "m28.png", round: 5, counterId: "c9" },
//     // { id: "m29", title: "DNA upgrades unlock psychic abilities", type: "claim", image: "m29.png", round: 5, counterId: "c7" },
//     { id: "m19", title: "Vaccines contain microchips", type: "claim", image: "m13.png", round: 5, counterId: "c2" },
//     { id: "m20", title: "Brainwaves can be altered remotely by the government", type: "claim", image: "m30.png", round: 5, counterId: "c7" },
// ];


export const CLAIM_CARDS = [
    // Round 1: Basic Health Myths
    {
        id: "m1",
        title: "Drinking bleach detoxifies the body",
        type: "claim",
        image: "m1.png",
        round: 1,
        category: "Health Misinfo",
        counterId: "c1",
        right: "Uses trusted health verification to refute dangerous medical advice.",
        wrong: "Player fails to stop a harmful health myth.",
    },
    {
        id: "m2",
        title: "The Great Wall of China is visible from space",
        type: "claim",
        image: "m2.png",
        round: 1,
        category: "Viral Myth",
        counterId: "c9",
        right: "Busts an urban legend using historical fact-checking.",
        wrong: "Player reinforces a common space myth.",
    },
    {
        id: "m3",
        title: "Sunlight kills all viruses instantly",
        type: "claim",
        image: "m3.png",
        round: 1,
        category: "Health Misinfo",
        counterId: "c6",
        right: "Highlights proper disinfection and health safety standards.",
        wrong: "Spreads a dangerous oversimplification of virus control.",
    },
    {
        id: "m4",
        title: "Holding breath for 10 seconds proves you're virus-free",
        type: "claim",
        image: "m4.png",
        round: 1,
        category: "Health Misinfo",
        counterId: "c3",
        right: "Corrects a viral myth using public health media tactics.",
        wrong: "Fails to counter a widely-shared fake test method.",
    },

    // Round 2: Alternative Cures & Detox Fads
    {
        id: "m5",
        title: "Homeopathy is a proven COVID cure",
        type: "claim",
        image: "m5.png",
        round: 2,
        category: "Pseudoscience",
        counterId: "c2",
        right: "Exposes fake science posing as legitimate treatment.",
        wrong: "Lets pseudo-scientific treatments gain credibility.",
    },
    {
        id: "m6",
        title: "You can detox through your feet",
        type: "claim",
        image: "m6.png",
        round: 2,
        category: "Pseudoscience",
        counterId: "c4",
        right: "Debunks a common wellness scam with myth-based tools.",
        wrong: "Player allows pseudoscientific health myths to persist.",
    },
    {
        id: "m7",
        title: "Wearing copper bracelets boosts immunity",
        type: "claim",
        image: "m7.png",
        round: 2,
        category: "Pseudoscience",
        counterId: "c5",
        right: "Uses scientific testing logic to dismantle the immunity claim.",
        wrong: "Fails to challenge a tech-looking placebo product.",
    },
    {
        id: "m8",
        title: "Natural remedies are always safe",
        type: "claim",
        image: "m8.png",
        round: 2,
        category: "Health Misinfo",
        counterId: "c6",
        right: "Reinforces that 'natural' doesn't equal safe in medicine.",
        wrong: "Player enables risky health beliefs.",
    },

    // Round 3: Viral Social Myths & Fringe Beliefs
    {
        id: "m9",
        title: "Bill Gates owns the WHO",
        type: "claim",
        image: "m9.png",
        round: 3,
        category: "Conspiracy/Viral",
        counterId: "c8",
        right: "Disproves global conspiracy with wide-scale verification.",
        wrong: "Allows billionaire conspiracy to spread further.",
    },
    {
        id: "m10",
        title: "DNA upgrades unlock psychic abilities",
        type: "claim",
        image: "m10.png",
        round: 3,
        category: "Pseudoscience",
        counterId: "c7",
        right: "AI logic debunks the sci-fi pseudoscience blend.",
        wrong: "Fails to call out fringe fantasy as fake.",
    },
    {
        id: "m11",
        title: "5G towers spread dangerous radiation",
        type: "claim",
        image: "m11.png",
        round: 3,
        category: "Tech/Health Myth",
        counterId: "c2",
        right: "Uses scientific literature to dismiss tech-related fear.",
        wrong: "Spreads anti-technology paranoia.",
    },
    {
        id: "m12",
        title: "Social distancing is a government control tactic",
        type: "claim",
        image: "m12.png",
        round: 3,
        category: "Viral/Conspiracy",
        counterId: "c3",
        right: "Media counter corrects public misconception effectively.",
        wrong: "Undermines public health through mistrust.",
    },

    // Round 4: Conspiracies & Misinformation Campaigns
    {
        id: "m13",
        title: "The moon landing was faked",
        type: "claim",
        image: "m13.png",
        round: 4,
        category: "Conspiracy Myth",
        counterId: "c9",
        right: "Debunks a classic hoax using archival facts.",
        wrong: "Player revives old conspiracies.",
    },
    {
        id: "m14",
        title: "Scientists are paid to lie about climate change",
        type: "claim",
        image: "m14.png",
        round: 4,
        category: "Conspiracy",
        counterId: "c2",
        right: "Defends science with data-backed truth.",
        wrong: "Implicates scientists in false narratives.",
    },
    {
        id: "m15",
        title: "Big Pharma suppresses all cures",
        type: "claim",
        image: "m15.png",
        round: 4,
        category: "Conspiracy/Health",
        counterId: "c5",
        right: "Counters suppression myths using research and data.",
        wrong: "Reinforces distrust in health institutions.",
    },
    {
        id: "m16",
        title: "The government controls weather with chemtrails",
        type: "claim",
        image: "m16.png",
        round: 4,
        category: "Conspiracy/Tech",
        counterId: "c8",
        right: "Takes down a broad myth with global fact-checking.",
        wrong: "Legitimizes climate-control conspiracies.",
    },

    // Round 5: Deep Pseudoscience & Tech Myths
    {
        id: "m17",
        title: "Quantum healing can cure cancer instantly",
        type: "claim",
        image: "m17.png",
        round: 5,
        category: "Pseudoscience",
        counterId: "c1",
        right: "Uses medical tools to fight fake science.",
        wrong: "Player spreads a dangerous false cure.",
    },
    {
        id: "m18",
        title: "Time-travelers warned us about pandemics",
        type: "claim",
        image: "m18.png",
        round: 5,
        category: "Sci-fi Myth",
        counterId: "c9",
        right: "Exposes time-travel lore using historical evidence.",
        wrong: "Lets fantasy blend into perceived reality.",
    },
    {
        id: "m19",
        title: "Vaccines contain microchips",
        type: "claim",
        image: "m19.png",
        round: 5,
        category: "Tech/Conspiracy",
        counterId: "c7",
        right: "Discredits the digital surveillance myth using AI tools.",
        wrong: "Player amplifies a widely spread vaccine lie.",
    },
    {
        id: "m20",
        title: "Brainwaves can be altered remotely by the government",
        type: "claim",
        image: "m20.png",
        round: 5,
        category: "Tech/Conspiracy",
        counterId: "c4",
        right: "Dissects myth with pseudoscience debunking logic.",
        wrong: "Allows wild fringe tech myths to spread.",
    }
];
  